// these must be in sync with the backend app/Models/Permission.php
export const PermissionEnum = {
  Admin: "admin",
  MasterAccount: "master-account",
  OrdersViewAccount: "orders.view_account",
  OrdersViewAssigned: "orders.view_assigned",
  OrdersViewAvailable: "orders.view_available",
  OrdersClaim: "orders.claim",
  OrdersAssignDriver: "orders.assign_driver",
  OrdersAccept: "orders.accept",
  OrdersManageEquipment: "orders.manage_equipment",
  InspectionsSubmit: "inspections.submit",
  InspectionsView: "inspections.view",
  LoadsSearch: "loads.search",
  UsersManageRoles: "users.manage_roles",
  AccountManage: "account.manage",
};
